import "./Skeleton.css";

interface SkeletonProps {
	width?: string | number;
	height?: string | number;
	borderRadius?: string | number;
	className?: string;
	circle?: boolean;
	style?: React.CSSProperties;
}

export const Skeleton = ({
	width,
	height,
	borderRadius,
	className = "",
	circle = false,
	style = {},
}: SkeletonProps) => {
	const combinedStyle: React.CSSProperties = {
		width,
		height,
		borderRadius: circle ? "50%" : borderRadius,
		...style,
	};

	return <div className={`skeleton ${className}`} style={combinedStyle} />;
};
